import sitemenulinks from './sitemenulinks'
import sitedata from './sitedata'
import winners from './winners'
import nominees from './nominees'
import background from './bg'
import sbApiRequests from './sbApiRequests'

const config = {
  ...sitemenulinks,
  ...sitedata,
  ...winners,
  ...nominees,
  ...background,
  ...sbApiRequests,
  datadog: {
    applicationId: '1fbcabde-890e-4786-84e5-f43de0c0174e',
    clientToken: 'pub71bfd2b8d9ccf7009b9926d564dbc72f',
    site: 'us5.datadoghq.com',
    service: 'martech',
    sessionSampleRate: 20,
    sessionReplaySampleRate: 10,
    trackBfcacheViews: true,
    trackResources: true,
    defaultPrivacyLevel: 'mask-user-input',
  },
}

export default config
